import React from 'react';

export default function TermsOfService() {
  return (
    <main className="relative overflow-hidden px-6 py-24">
      {/* Soft background */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_20%,rgba(99,102,241,0.12),transparent_60%)]" />
        <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(99,102,241,0.06)_1px,transparent_1px),linear-gradient(to_bottom,rgba(99,102,241,0.06)_1px,transparent_1px)] bg-[size:72px_72px]" />
      </div>

      <div className="mx-auto max-w-4xl">
        {/* Header */}
        <header className="mb-16 text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl dark:text-gray-100">
            Terms of Service
          </h1>
          <p className="mt-4 text-base text-gray-600 dark:text-gray-300">
            These terms govern your access to and use of Akwid Labs’ website and services.
          </p>
          <p className="mt-2 text-sm text-gray-500">Last updated: {new Date().getFullYear()}</p>
        </header>

        {/* Content */}
        <section className="space-y-12 leading-relaxed text-gray-700 dark:text-gray-300">
          <div>
            <h2 className="mb-3 text-xl font-semibold text-gray-900 dark:text-gray-100">
              1. Acceptance of Terms
            </h2>
            <p>
              By accessing or using this website or our services, you agree to be bound by these
              Terms of Service. If you do not agree, you should not use our platform or services.
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-xl font-semibold text-gray-900 dark:text-gray-100">
              2. About Akwid Labs
            </h2>
            <p>
              Akwid Labs (Pvt) Ltd is a technology company providing software engineering, AI & data
              solutions, telecom engineering, FinTech services, design, and consulting services to
              startups and enterprises globally.
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-xl font-semibold text-gray-900 dark:text-gray-100">
              3. Use of Services
            </h2>
            <ul className="list-disc space-y-2 pl-6">
              <li>You agree to use our services only for lawful purposes</li>
              <li>You must not misuse, disrupt, or attempt to gain unauthorized access</li>
              <li>You are responsible for the accuracy of information you provide to us</li>
            </ul>
          </div>

          <div>
            <h2 className="mb-3 text-xl font-semibold text-gray-900 dark:text-gray-100">
              4. Intellectual Property
            </h2>
            <p>
              All content, designs, code, trademarks, and materials on this website are the
              intellectual property of Akwid Labs unless otherwise stated. You may not copy,
              reproduce, or distribute any material without prior written permission.
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-xl font-semibold text-gray-900 dark:text-gray-100">
              5. Client Projects & Deliverables
            </h2>
            <p>
              Ownership of project deliverables, source code, and intellectual property will be
              governed by individual project agreements or contracts. Nothing in these Terms
              overrides signed client agreements.
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-xl font-semibold text-gray-900 dark:text-gray-100">
              6. Confidentiality
            </h2>
            <p>
              Both parties agree to maintain confidentiality of sensitive or proprietary information
              shared during discussions or engagements, unless disclosure is required by law.
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-xl font-semibold text-gray-900 dark:text-gray-100">
              7. Limitation of Liability
            </h2>
            <p>
              To the maximum extent permitted by law, Akwid Labs shall not be liable for any
              indirect, incidental, or consequential damages arising from the use or inability to
              use our services or website.
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-xl font-semibold text-gray-900 dark:text-gray-100">
              8. Third-Party Links
            </h2>
            <p>
              Our website may contain links to third-party websites or services. We are not
              responsible for their content, policies, or practices.
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-xl font-semibold text-gray-900 dark:text-gray-100">
              9. Termination
            </h2>
            <p>
              We reserve the right to suspend or terminate access to our website or services if
              these terms are violated or if misuse is detected.
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-xl font-semibold text-gray-900 dark:text-gray-100">
              10. Changes to Terms
            </h2>
            <p>
              We may update these Terms of Service from time to time. Continued use of our services
              after changes indicates acceptance of the updated terms.
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-xl font-semibold text-gray-900 dark:text-gray-100">
              11. Governing Law
            </h2>
            <p>
              These Terms shall be governed by and interpreted in accordance with the laws of Sri
              Lanka, without regard to conflict of law principles.
            </p>
          </div>

          <div>
            <h2 className="mb-3 text-xl font-semibold text-gray-900 dark:text-gray-100">
              12. Contact Information
            </h2>
            <p>
              For questions regarding these Terms of Service, contact us at{' '}
              <a
                href="mailto:hello@akwidlabs.com"
                className="font-medium text-indigo-500 hover:text-indigo-400"
              >
                hello@akwidlabs.com
              </a>
              .
            </p>
          </div>
        </section>
      </div>
    </main>
  );
}
